module.exports = {
	...require('./MuiEditorContainer'),
};
